class AccountModal extends HTMLElement {
  constructor() {
    super();
    
    this.overlay = document.querySelector('.account-modal__overlay');
    this.closeButton = this.querySelector('.account-modal__close');
    this.activeElement = null;
    
    // Set up event listeners
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    // Ensure overlay click closes the modal
    if (this.overlay) {
      this.overlay.addEventListener('click', (event) => {
        // Only close if clicking directly on the overlay (not its children)
        if (event.target === this.overlay) {
          this.close();
        }
      });
    }
    
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this));
    }
  }
  
  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    
    // Add active class to show the modal
    this.classList.add('active');
    this.scrollLock();
    
    // Show the overlay
    if (this.overlay) {
      this.overlay.classList.add('active');
    }
    
    // Focus management: Immediately focus the first focusable element in the modal.
    const focusElement = this.querySelector('.account-modal__close') || this.querySelector('[tabindex="0"]');
    if (focusElement && window.innerWidth > 768) {
      focusElement.focus();
    }
    
    // Dispatch custom event for external listeners
    this.dispatchEvent(new CustomEvent('modal:opened', {
      bubbles: true,
      detail: { modal: this }
    }));
  }
  
  close() {
    // Remove active classes
    this.classList.remove('active');
    this.scrollUnlock();
    
    // Hide the overlay
    if (this.overlay) {
      this.overlay.classList.remove('active');
    }
    
    // Return focus to the element that triggered the modal
    if (this.activeElement && typeof this.activeElement.focus === 'function') {
      this.activeElement.focus();
    }
    
    // Dispatch custom event for external listeners
    this.dispatchEvent(new CustomEvent('modal:closed', {
      bubbles: true,
      detail: { modal: this }
    }));

    window.dispatchEvent(new CustomEvent('account-modal-closed'));

  }
  
  // Method to update modal content dynamically
  setContent(title, subtitle, content) {
    const titleElement = this.querySelector('.account-modal__title');
    const subtitleElement = this.querySelector('.account-modal__subtitle');
    const contentElement = this.querySelector('.account-modal__content');
    
    if (titleElement && title) {
      titleElement.textContent = title;
    }
    
    if (subtitleElement && subtitle) {
      subtitleElement.textContent = subtitle;
    }
    
    if (contentElement && content) {
      if (typeof content === 'string') {
        contentElement.innerHTML = content;
      } else if (content instanceof HTMLElement) {
        contentElement.innerHTML = '';
        contentElement.appendChild(content);
      }
    }
  }
  
  // Method to get modal content element for external manipulation
  getContentElement() {
    return this.querySelector('.account-modal__content');
  }

  scrollLock() {
    this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    this.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollTop}px`;
    document.body.style.width = '100%';
  }

  scrollUnlock() {
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(this.scrollLeft, this.scrollTop);
  }
}
// Define the custom element
customElements.define('account-modal', AccountModal);
export default AccountModal;
